import React, { FunctionComponent } from 'react';
import {
  Dimensions,
  ImageBackground,
  Platform, SafeAreaView,
  StyleProp,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native';
import { Icon } from '../../components';
import Theme from '../../theme';
import { LinearGradient } from '../../ui';
import { defaultScale } from '../../utils/scaling';
import { isLarge } from '../../utils/ScreenSizes';

interface IProps {
  title?: string;
  subtitle?: string;
  description?: string;
  actions?: React.ReactNode;
  containerStyle?: StyleProp<ViewStyle>;
  titleStyle?: StyleProp<ViewStyle>;
  contentContainerStyle?: StyleProp<ViewStyle>;
  imageSource: any;
  useGradient?: boolean;
  gradientHeight?: string;
  gradientOpacity?: number;
  onClosePress?: () => void;
}

export const TrackingImageTile: FunctionComponent<IProps> = ({
  title,
  subtitle,
  description,
  actions,
  containerStyle,
  titleStyle,
  useGradient,
  imageSource,
  gradientHeight = '100%',
  gradientOpacity = 0.6,
  onClosePress,
  contentContainerStyle,
}) => (
  <View style={[!containerStyle && styles.container, containerStyle]}>
    <ImageBackground
      source={imageSource}
      style={[styles.image]}
      resizeMode='cover'
    >
      {onClosePress
          && (
          <TouchableOpacity
            onPress={onClosePress}
            style={[styles.closeIconContainerStyle]}
            hitSlop={{
              bottom: 20, top: 20, left: 20, right: 20,
            }}
          >
            <SafeAreaView style={{ flex: 0 }} />
            <Icon name='md-close' color={Theme.WHITE} size={defaultScale(30)} />
          </TouchableOpacity>
          )}
      <View style={
          [
            styles.contentContainer,
            contentContainerStyle,
            { marginTop: actions ? undefined : defaultScale(isLarge ? 320 : 160) },
          ]
}
      >
        {
            title
            && <Text style={[styles.title, titleStyle]}>{title}</Text>
          }
        {
            subtitle
            && <Text style={styles.subtitle}>{subtitle}</Text>
          }
        {
            description
            && <Text style={styles.description}>{description}</Text>
          }
        {actions}
      </View>
      {
          useGradient
          && (
          <LinearGradient
            colors={['transparent', Theme.BLACK]}
            style={[styles.gradient, { height: gradientHeight, opacity: gradientOpacity }]}
            webClassName='tracking-tile-image'
          />
          )
        }
    </ImageBackground>
  </View>
);

const styles = StyleSheet.create({
  container: {
    height: defaultScale(350),
  },
  image: {
    width: '100%',
    height: '100%',
  },
  contentContainer: {
    zIndex: 10,
    flex: 1,
    justifyContent: 'flex-end',
    marginVertical: defaultScale(10),
    marginHorizontal: defaultScale(12),
    paddingBottom: defaultScale(15),
  },
  title: {
    ...Theme.textStyle.heading,
    color: Theme.WHITE,
    paddingVertical: defaultScale(5),
  },
  subtitle: {
    ...Theme.textStyle.bodyCopyReg,
    color: Theme.WHITE,
    marginTop: defaultScale(1),
    marginBottom: defaultScale(14),
  },
  description: {
    ...Theme.graphStyle.regular18,
    color: Theme.WHITE,
    marginTop: defaultScale(8),
    marginBottom: defaultScale(15),
  },
  gradient: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    left: 0,
  },
  closeIconContainerStyle: {
    alignSelf: 'flex-end',
    margin: defaultScale(15),
    zIndex: 10,
  },
});
